import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { CustomUser } from 'api';
import { IUser, resetUserState, updateUserState } from 'dashboard409a/states/features/user';

// This is the single legacy bridge between auth and dashboard Redux user state.
// When dashboard no longer reads the Redux user slice, delete this hook and its callsites.
const useDashboardReduxUserSync = () => {
  const dispatch = useDispatch();

  const syncDashboardUser = useCallback(
    (userInfo: CustomUser) => {
      dispatch(updateUserState(userInfo as unknown as IUser));
    },
    [dispatch]
  );

  const resetDashboardUser = useCallback(() => {
    dispatch(resetUserState());
  }, [dispatch]);

  return {
    resetDashboardUser,
    syncDashboardUser,
  };
};

export default useDashboardReduxUserSync;
